import { Component, Input } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { RangeScaleComponent } from 'src/app/feature-modules/shared-module/range-scale/range-scale.component';
import { scaleConfig } from 'src/app/feature-modules/shared-module/range-scale/range-scale.config';
import { ScaleType } from 'src/app/feature-modules/shared-module/range-scale/range-scale.model';
import { WaterQualityStatus } from 'src/app/interface-model/app-interface-model';

@Component({
    selector: 'app-sanitization',
    templateUrl: './sanitization.component.html',
    styleUrls: ['./sanitization.component.css'],
    standalone: false
})
export class SanitizationComponent {
  @Input() sanitizationDetails:any;
  @Input() sanitizationEquipmentList:any;

  scaleType = ScaleType;
  constructor(private modalService: BsModalService) { }

openModal(type: ScaleType) {
  const initialState = scaleConfig[type];
  this.modalService.show(RangeScaleComponent, {
    class: 'modal-lg',
    initialState
  });
}

getEquipmentIcon(type: string): string {
  switch (type) {
    case 'sanitizer':
      return 'assets/img/chlorinator.svg';
    case 'truSense':
      return 'assets/img/tru_sense.svg';
    default:
      return 'assets/img/chlorinator.svg';
  }
}

  // Helper: Determine salt level status (ppm)
  getSaltStatus(value: number): WaterQualityStatus {
    if (value < 2500 || value > 4000) return "actionRequired";
    if (value < 3000 || value > 3500) return "needsAttention";
    return "normal";
  };

  // Helper: Determine ORP level status (mV)
  getOrpStatus(value: number): WaterQualityStatus {
    if (value < 550 || value > 900) return "actionRequired";
    if (value < 650 || value > 800) return "needsAttention";
    return "normal";
  };

getStatusLabel(reading: any): string {
  switch (reading.type) {
    case 'salt':
      return this.getSaltStatus(reading.value);
    case 'orp':
      return this.getOrpStatus(reading.value);
    default:
      return 'Unknown';
  }
}

getStatusIcon(reading: any): string {
  switch (this.getStatusLabel(reading)) {
    case 'normal':
      return 'assets/img/normal-status.svg';
    case 'needsAttention':
      return 'assets/img/needs-attention.svg';
    case 'actionRequired':
      return 'assets/img/redWarning.svg';
    default:
      return '';
  }
}

}
